import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ButtonComponent } from "../../components/button/button.component";
import { HeaderComponent } from "../../components/header/header.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { DistrictService } from '../../services/district.service';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { CommonModule } from '@angular/common';
import { DropdownService } from '../../services/dropdown.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';

@Component({
  selector: 'app-evaluator-list-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, SelectInputComponent, AgGridListComponent, BulkUploadComponent, SearchInputComponent],
  templateUrl: './evaluator-list-page.component.html',
  styleUrl: './evaluator-list-page.component.css'
})
export class EvaluatorListPageComponent {
@ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Evaluator';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any = [];
  @Input() show_heder = true

  cols:any = [
  { headerName: "#", valueGetter: (p:any) => p.node.rowIndex + 1, width: 80 },
  { field: "subject_name", headerName: "Subject Name", flex: 1 },
  { field: "L1", headerName: "L1", width: 120 },
  { field: "L2", headerName: "L2", width: 120 },
  { field: "L3", headerName: "L3", width: 120 },
  { field: "L4", headerName: "L4", width: 120 },
  { field: "L5", headerName: "L5", width: 120 },
  { field: "max_score", headerName: "Maximum Score", width: 150 },
  { field: "pages", headerName: "No. of Pages", width: 150 },
  { field: "checked_by_me", headerName: "Checked By Me?", width: 160 },
  { headerName: "Recheck", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
];


    bulk_columns = [
    { column_name: 'Country Name', type: 'text', return_as: 'country_id', sample_value: 'India' },
    { column_name: 'State Name', type: 'text', return_as: 'state_id', sample_value: 'Maharashtra' },
    { column_name: 'Division Name', type: 'text', return_as: 'division_id', sample_value: 'Mumbai' },
    { column_name: 'District Name', type: 'text', return_as: 'name', sample_value: 'Mumbai City' },
    { column_name: 'Code', type: 'text', return_as: 'code', sample_value: 'Mumbai' },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky',icon:'bx bx-refresh', function: this.open_delete_modal.bind(this) })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ds: DistrictService, public ar: ActivatedRoute, public dds: DropdownService,) {
    this.form = this.fb.group({
      country_id: ['', [Validators.required]],
      state_id: ['', [Validators.required]],
      division_id: ['', [Validators.required]],
      name: ['', [Validators.required]],
      code: ['', [Validators.required,Validators.minLength(2), Validators.maxLength(10),Validators.pattern('^[a-zA-Z0-9]+$')]],
    });
  }
  async ngOnInit() {
     await this.dds?.get_dropdown_list(['country', 'state', 'division', 'district']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
    })
    this.items = {
  data: [
    {
      subject_name: "Artificial Intelligence Grade 9th (ARI-001)",
      L1: 25,
      L2: "-",
      L3: "-",
      L4: "-",
      L5: "-",
      max_score: 25,
      pages: 8,
      checked_by_me: "No"
    },
    {
      subject_name: "Artificial Intelligence Grade 9th (ARI-001)",
      L1: 34.5,
      L2: "-",
      L3: "-",
      L4: "-",
      L5: "-",
      max_score: 34.5,
      pages: 8,
      checked_by_me: "No"
    },
    {
      subject_name: "Artificial Intelligence Grade 9th (ARI-001)",
      L1: 32,
      L2: "-",
      L3: "-",
      L4: "-",
      L5: "-",
      max_score: 32,
      pages: 8,
      checked_by_me: "No"
    },
    {
      subject_name: "Artificial Intelligence Grade 9th (ARI-001)",
      L1: 31,
      L2: "-",
      L3: "-",
      L4: "-",
      L5: "-",
      max_score: 31,
      pages: 8,
      checked_by_me: "No"
    },
    {
      subject_name: "Artificial Intelligence Grade 9th (ARI-001)",
      L1: 37,
      L2: "-",
      L3: "-",
      L4: "-",
      L5: "-",
      max_score: 37,
      pages: 8,
      checked_by_me: "No"
    },
    {
      subject_name: "Artificial Intelligence Grade 9th (ARI-001)",
      L1: 34,
      L2: "-",
      L3: "-",
      L4: "-",
      L5: "-",
      max_score: 34,
      pages: 8,
      checked_by_me: "No"
    },
    {
      subject_name: "Artificial Intelligence Grade 9th (ARI-001)",
      L1: 44.5,
      L2: "-",
      L3: "-",
      L4: "-",
      L5: "-",
      max_score: 44.5,
      pages: 8,
      checked_by_me: "No"
    },
    {
      subject_name: "Artificial Intelligence Grade 9th (ARI-001)",
      L1: 29.5,
      L2: "-",
      L3: "-",
      L4: "-",
      L5: "-",
      max_score: 29.5,
      pages: 8,
      checked_by_me: "No"
    },
    {
      subject_name: "Artificial Intelligence Grade 9th (ARI-001)",
      L1: 41.5,
      L2: "-",
      L3: "-",
      L4: "-",
      L5: "-",
      max_score: 41.5,
      pages: 8,
      checked_by_me: "No"
    },
    {
      subject_name: "Artificial Intelligence Grade 9th (ARI-001)",
      L1: 42.5,
      L2: "-",
      L3: "-",
      L4: "-",
      L5: "-",
      max_score: 42.5,
      pages: 8,
      checked_by_me: "No"
    }
  ],
  count: 10
};

  }
  async get_list(filter?: any) {
    try {
      this.items = await this.ds.get_list(filter);
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
 async open_delete_modal(item: any, index: any) {
  this.route.navigate(['/evalution']);
}
  async delete() {
    let res = await this.ds.delete(this.selected_ids.id);
    if (res != undefined) {
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    }
    this.selected_ids = {};
    this.confirmation_delete_modal?.close()
    await this.get_list(this.params);
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      let res = await this.ds.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    await this.get_list(this.params);
  }
async  open_form_modal(item?: any) {
    this.selected_ids = item || {};
    if (this.selected_ids && this.selected_ids.id) {
    let response = await this.ds.get(item.id);
      this.selected_ids = {...response.data};
      this.form.patchValue({...this.selected_ids,});
    } else {
      this.selected_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    if (this.form.invalid) {
      this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
      this.form.markAllAsTouched();
      return;
    }
    let form_value = this.form.value;
    if (this.selected_ids && this.selected_ids.id) {
      let update_response = await this.ds.update(this.selected_ids.id, form_value);
      this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
    } else {
      let create_response = await this.ds.add(form_value);
      this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
    }
    await this.get_list(this.params);
    this.close_form_modal();
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      await this.gs.bulk_form_submission(data, this.ds, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
    }
  }

}
